<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('safes.form.addCustomer')"
          :description="$t('safes.form.fromHereYouCanCreateANewCustomer')"
          v-if="$route.name == 'safesPublicCreate'"
        />
        <addHeader
          :title="$t('safes.form.editCustomer')"
          :description="
            $t('safes.form.fromHereYouCanModifyTheCustomerInformation')
          "
          v-if="$route.name == 'safesPublicEdit'"
        />
        <div class="mb-4 row">
          <dvider
            :title="$t('safes.form.basicInformation')"
            :description="$t('safes.form.safesBasicInformation')"
            noLine="true"
          />
          <formInput
            :title="$t('safes.form.customerName')"
            :checkError="'nameErorr'"
            v-model="item.name"
            :hasErorr="errors.name"
            :error="$t('allerts.thisFieldIsRequired')"
            maxlength="255" 
          />
        
          <monyInput
            :title="$t('safes.form.initialBalance')"
            v-model="item.balance"
            :disabled="this.$route.name == 'safesEdit' ? true : false"
          />
          <checkInput
            :title="$t('safes.form.customerCase')"
            :value="item.stat"
            v-model="item.stat"
          />
          <formInput
            :title="$t('safes.form.conversionFactor')"
            :checkError="'nameErorr'"
            v-model="item.name"
            :hasErorr="errors.name"
            :error="$t('allerts.thisFieldIsRequired')"
            maxlength="255" 
          />

          <dvider
            :title="$t('safes.form.billingAddress')"
            :description="
              $t('safes.form.theTitleOfBillingAndTheInvoiceIsRecorded')
            "
          />
          <formInput
            :title="$t('safes.form.title')"
            v-model="item.address1"
            maxlength="255" 
          />
          <formInput
            :title="$t('safes.form.supplement')"
            v-model="item.address2"
            maxlength="255" 
          />
          <formInput
            :title="$t('safes.form.theEntity')"
            v-model="item.entity"
            maxlength="255" 
          />
          <formInput
            :title="$t('safes.form.city')"
            v-model="item.city"
            maxlength="255" 
          />
          <formInput
            :title="$t('safes.form.postalCode')"
            v-model="item.zip"
            maxlength="255" 
          />
          <formInput
            :title="$t('safes.form.theState')"
            v-model="item.country"
            maxlength="255" 
          />
          <hr class="mt-5 mb-5 col-12" />
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'safesPublicCreate' && !$parent.stopEdit"
          >
            {{ $t('safes.form.addCustomer') }}
          </a>
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'safesPublicEdit' && !$parent.stopEdit"
          >
            {{ $t('safes.form.editCustomer') }}
          </a>
          <loading v-if="$parent.stopEdit"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

import formInput from "../elements/add/form/formInput.vue";
import monyInput from "../elements/add/form/monyInput.vue";
import checkInput from "../elements/add/form/checkInput.vue";
import dvider from "../elements/add/dvider.vue";
import addHeader from "../elements/add/header.vue";
import loading from "../elements/add/loading.vue";
export default {
  data() {
    return {
      path: "/safesPublic",
      item: {
        stat: 1,
      },
      errors: {
        name: false,
      },
      readyUsers: 0,
    };
  },
  methods: {
    saveItem() {
      var error = 0;
      if (typeof this.item.name === "undefined" || this.item.name == "") {
        error = 1;
        this.errors.name = true;
      }
      if (error == 0) {
        if (this.$route.name == "safesCreate") {
          this.$parent.aletText = this.$t('allerts.safesuccessfullyAdde');
          this.$parent.alertType = "success";
          this.$addToLocalDatabase(this.item, this.path.substring(1));
          this.$router.go(-1);
        } else if (this.$route.name == "safesEdit") {
          this.item._method = "PUT";
          this.$parent.stopEdit = true;
          axios
            .post(this.$linkGnirator(this.path + "/" + this.item.id), this.item)
            .then((response) => {
              this.$parent.aletText =
                this.$t('allerts.customerHasBeenModifiedSuccessfully');
              this.$parent.alertType = "success";
              this.$router.go(-1);
              this.$parent.stopEdit = false;
              return response;
            });
        }
      } else {
        this.$parent.aletText = this.$t('allerts.pleaseMakeSureOfTheInput');
        this.$parent.alertType = "danger";
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    getItem() {
      var item = this.$database.safes.find(
        (el) => el.id == this.$route.params.id
      );
      if (item) {
        this.item = item;
      }
      this.$parent.stopEdit = false;
    },
  },
  mounted() {
    if (this.$route.name == "safesEdit") {
      this.$parent.stopEdit = true;
      this.getItem();
    }

    var elm = this;
      window.addEventListener("keydown", function (e) {
        if (e.key == "F1" || e.key == "Meta") {
          e.preventDefault();
          elm.saveItem();
        }
    })
  },
  components: {
    formInput,
    dvider,
    addHeader,
    monyInput,
    checkInput,
    loading,
  },
};
</script>
<style></style>
